// extracted by mini-css-extract-plugin
module.exports = {"ss-lottie-container":"ss-lottie-container_2K92u"};